import { definePlugin } from '../../code-plug';

import { PublishedFormsSidebar } from './views/published-form-sidebar';

definePlugin('dashboard-published-forms', ({ registerView }, params) => {
  registerView('dashboard-sidebar', PublishedFormsSidebar, params);
});
